export const truncate = (copy, limit) => {
    if (copy.length <= limit) {
        return copy;
    }
    const copyWithLimitApplied = copy.slice(0, limit);
    const indexOfLastSpace = copyWithLimitApplied.includes(' ') ? copyWithLimitApplied.lastIndexOf(' ') : limit;
    const sliceIndex = copy[indexOfLastSpace - 1].match(/[a-zA-Z0-9]/) ? indexOfLastSpace : indexOfLastSpace - 1;
    return `${copy.slice(0, sliceIndex)}...`;
};
export const truncateTextWithEllipsis = (text, characterLimit, addEllipsis = true) => {
    if (text.length <= characterLimit) {
        return text;
    }
    const specialChars = ['.', ',', '!', '?', '-', '—', ' '];
    let truncatedText = text.substring(0, characterLimit);
    if (addEllipsis) {
        const lastTruncatedChar = () => truncatedText.charAt(truncatedText.length - 1);
        const hasSpecialLastChar = () => specialChars.includes(lastTruncatedChar());
        truncatedText = truncatedText.substring(0, Math.min(truncatedText.length, truncatedText.lastIndexOf(' ')));
        while (hasSpecialLastChar()) {
            truncatedText = truncatedText.substring(0, truncatedText.length - 1);
        }
        truncatedText = `${truncatedText}\u2026`;
    }
    return truncatedText;
};
export const trimAndRemoveExtraWhitespace = (string) => {
    return string.replace(/\s\s+/g, ' ').trim();
};
export const capitalsToTitleCase = (string) => {
    return string.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substr(1).toLowerCase());
};
export const fromUriParameterToSearchParameter = (string) => {
    return string.replace(/-/g, ' ');
};
export const fromSearchParameterToUriParameter = (string) => {
    return string.replace(/ /g, '-');
};
export const replaceSpecialCharactersWith = (string, replaceWith = '-', trimReplacedWithFromEnds = true) => {
    let replacedString = string.replace(/[^a-zA-Z0-9]/g, replaceWith).trim();
    if (trimReplacedWithFromEnds) {
        if (replacedString.charAt(0) === replaceWith) {
            replacedString = replacedString.slice(1);
        }
        if (replacedString.charAt(replacedString.length - 1) === replaceWith) {
            replacedString = replacedString.slice(0, replacedString.length - 1);
        }
    }
    return replacedString.trim();
};
export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};
export const isValidRomanNumeral = (string) => {
    if (!string) {
        return false;
    }
    return !!string.match(/^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/i);
};
export const isValidUuid = (value) => {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);
};
export const formatCurrency = (value, decimalplaces) => {
    if (!value) {
        return '£0';
    }
    let numberOfDecimalPlaces = decimalplaces != null ? decimalplaces : 0;
    if (Number.isInteger(value) || decimalplaces === 0) {
        numberOfDecimalPlaces = 0;
    }
    return Number(value).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: numberOfDecimalPlaces,
        maximumFractionDigits: numberOfDecimalPlaces,
    });
};
export const camelCaseToSnakeCase = (word) => {
    return word.split(/(?=[A-Z])/).reduce((words, word) => {
        if (!words)
            return word;
        return `${words}-${word.toLowerCase()}`;
    }, '');
};
export const pluralise = (word, count, suffix = 's') => {
    return count !== 1 ? word.concat(suffix) : word;
};
export const firstLetterToUppercase = (string) => string
    .split(' ')
    .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ');
export const makeStringSingular = (string) => {
    const stringEndInIes = string.substring(string.length - 3) === 'ies';
    if (stringEndInIes) {
        return string.substring(0, string.length - 3) + 'y';
    }
    const stringLastLetter = string.slice(-1);
    const stringSingular = stringLastLetter === 's' ? string.slice(0, -1) : string;
    return stringSingular;
};
export const replaceAllWith = (string, stringToReplace, replaceWith) => string.split(stringToReplace).join(replaceWith);
export const replaceAllSpacesWithPluses = (string) => string.replace(/\s/g, '+');
export const replaceAllSpacesWithHyphens = (string) => string.replace(/\s/g, '-');
export const replaceAllPlusesWithSpaces = (string) => string.replace(/\+/g, ' ');
export const replaceAllHyphensWithUnderscores = (string) => string.replace(/-/g, '_');
export const arrayToCommaOr = (array, oxfordComma = false) => {
    if (!array.length)
        return null;
    if (array.length === 1)
        return array[0].toString();
    if (array.length === 2)
        return `${array[0]} or ${array[1]}`;
    const lastItem = [...array].pop();
    const otherItems = array.slice(0, -1).join(', ');
    return `${otherItems}${oxfordComma ? ', ' : ' '}or ${lastItem}`;
};
export const commasInNumber = {
    add(value) {
        if (!value)
            return '';
        return typeof value === 'string' ? Number(value).toLocaleString() : value.toLocaleString();
    },
    remove(value) {
        if (!value)
            return '';
        return value.replace(/[^\d.-]/g, '');
    },
};
export const snakeAndSentenceCaseToLowerCaseKebabCase = (str) => {
    return str
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-');
};
